import { getMeasurementStatementTranslationKey } from "@msuite/utils/measurements";
import type { MeasurementStatementFormSchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { getMeasurementStatementColor, getMeasurementStatementIcon, Icon } from "../icons";
import { useTranslation } from "../localization";

/** Props Interface */
interface MeasurementStatementTagProps {
	statement: Nullable<MeasurementStatementFormSchema["statement"]>;
}

export function MeasurementStatementTag({ statement }: MeasurementStatementTagProps) {
	const { t } = useTranslation();

	/** Guard */
	if (!statement) return guardString(null);

	/** Render */
	return (
		<div className="h-stack">
			<Icon
				name={getMeasurementStatementIcon(statement)}
				color={`var(--color-${getMeasurementStatementColor(statement)}-500)`}
			/>
			<p>{t(getMeasurementStatementTranslationKey(statement))}</p>
		</div>
	);
}
